import { authenticatedFetch } from '../utils/apiInterceptor';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Create new payment link
export const createPaymentLink = async (linkData) => {
  const response = await authenticatedFetch(`${API_BASE_URL}/admin/payment-links/create/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    },
    body: JSON.stringify(linkData)
  });

  return response.json();
};

// Get payment links for a brand
export const getBrandPaymentLinks = async (brandId, filters = {}) => {
  const params = new URLSearchParams({
    brand_id: brandId.toString(),
    ...filters
  });

  try {
    const response = await authenticatedFetch(`${API_BASE_URL}/admin/payment-links/?${params}`, {
      headers: {
        'Authorization': `Bearer ${getAuthToken()}`
      }
    });

    return await response.json();
  } catch (error) {
    // Handle 404 as empty result - this happens when brand has no payment links
    if (error.status === 404) {
      console.log('No payment links found for brand (404)');
      return { status: 'success', payment_links: [] };
    }
    // Re-throw other errors
    throw error;
  }
};

// Update payment link
export const updatePaymentLink = async (linkId, updateData) => {
  const response = await authenticatedFetch(`${API_BASE_URL}/admin/payment-links/${linkId}/update/`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    },
    body: JSON.stringify(updateData)
  });

  return response.json();
};

// Get payment link analytics
export const getPaymentLinkAnalytics = async () => {
  const response = await authenticatedFetch(`${API_BASE_URL}/admin/payment-links/analytics/`, {
    headers: {
      'Authorization': `Bearer ${getAuthToken()}`
    }
  });

  return response.json();
};

// Get all payment links (for admin dashboard)
export const getAllPaymentLinks = async (filters = {}) => {
  const params = new URLSearchParams(filters);

  const response = await authenticatedFetch(`${API_BASE_URL}/admin/payment-links/?${params}`, {
    headers: {
      'Authorization': `Bearer ${getAuthToken()}`
    }
  });

  return response.json();
};

export const paymentLinkService = {
  createPaymentLink,
  getBrandPaymentLinks,
  updatePaymentLink,
  getPaymentLinkAnalytics,
  getAllPaymentLinks
};
